import { Link } from 'react-router';

export interface SidebarLogoProps {
  href: string;
  label: string;
  imageSrc?: string;
  tag?: string;
}

const stylesheet = {
  link: 'flex items-center justify-start min-w-12',
  text: 'font-bold leading-none text-start text-semantic-text-accent text-sidebar-logo',
  image: 'h-9 w-auto',
  tag: 'text-xs font-semibold uppercase tracking-wide text-semantic-text-secondary ml-2 self-end',
};

export function SidebarLogo({
  href,
  label,
  imageSrc,
  tag,
}: Readonly<SidebarLogoProps>) {
  return (
    <Link to={href} className={stylesheet.link}>
      {imageSrc ? (
        <img className={stylesheet.image} src={imageSrc} alt={label} />
      ) : (
        <span className={stylesheet.text}>{label}</span>
      )}
      {tag !== undefined && <span className={stylesheet.tag}>{tag}</span>}
    </Link>
  );
}
